module.exports = __webpack_public_path__ + "static/img/kv.a8f14bb.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/default/mobile_img/index1/kv.jpg
// module id = k0c0
// module chunks = 7